import { ArrowsOutIcon as PhosphorArrowsOutIcon } from "@phosphor-icons/react/dist/ssr/ArrowsOut";

import { createAppIcon } from "@/components/createAppIcon";

export const ExpandFullscreenIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowsOutIcon);
